import postRequest from '../../../../postRequest';

/**
 * Post request to send categories to OneStock Apisender.
 *
 * @param {number} siteCode JT
 */
export default function postCategoryOneStock(
  siteCode,
) {
  const endpoint = `/oc-data-management/v1/category/${siteCode}/`;

  return new Promise((resolve, reject) => {
    postRequest(endpoint, 'Send Category to OneStock')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
